import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { HiFinalCta, HI_PROCESS } from "./HindiHome";
import { EXPERIENCE_BRANDS } from "../data/site";

const HindiAbout = () => {
    useEffect(() => {
        document.title = "ALBL के बारे में | ब्रांड-मार्केटिंग अनुभव, नर्मदापुरम";
    }, []);

    return (
        <main lang="hi">
            <section className="bg-[#0D131F] hero-grid text-white pt-32 sm:pt-40 pb-16 sm:pb-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                    <Reveal>
                        <Eyebrow dark>ALBL के बारे में</Eyebrow>
                        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.15] mt-5 max-w-4xl" data-testid="hi-about-heading">
                            ALBL क्यों बना।
                        </h1>
                        <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                            ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर — बड़े ब्रांड्स के अनुभव पर बनी, मध्य प्रदेश के बाज़ारों के लिए।
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <p className="font-serif-accent italic text-xl sm:text-2xl text-slate-800 leading-relaxed">
                                लोकल बिज़नेस को महंगी कॉर्पोरेट एजेंसियों और साधारण डिजिटल मार्केटिंग पैकेजों के बीच चुनने की मजबूरी नहीं होनी चाहिए।
                            </p>
                            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
                                उन्हें गंभीर मार्केटिंग सोच मिलनी चाहिए — उनके बाज़ार, उनके ग्राहकों और उनके बिज़नेस की हक़ीक़त के अनुसार।
                            </p>
                            <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
                                LG, Haier और Bisleri जैसे ब्रांड्स के प्रोफ़ेशनल अनुभव के साथ, ALBL बढ़ने की इच्छा रखने वाले बिज़नेस तक व्यवस्थित ब्रांड-मार्केटिंग सोच पहुँचाती है।
                            </p>
                            <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
                                हम Instagram पोस्ट या मार्केटिंग पैकेज से शुरुआत नहीं करते। हम बिज़नेस से शुरुआत करते हैं — आप क्या बेचते हैं, कौन ख़रीदे, ग्राहक आपको ही क्यों चुने, आपके ग्राहक कहाँ छूट रहे हैं, और ग्रोथ क्या रोक रही है। फिर हम इन्हीं जवाबों के इर्द-गिर्द मार्केटिंग बनाते हैं।
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={150}>
                            <div className="border border-slate-200 bg-[#F8FAFC] p-8 sm:p-10">
                                <Eyebrow>प्रोफ़ेशनल अनुभव</Eyebrow>
                                <div className="mt-6 grid grid-cols-3 gap-3">
                                    {EXPERIENCE_BRANDS.map((b) => (
                                        <div
                                            key={b}
                                            className="border border-slate-200 bg-white py-6 flex items-center justify-center font-display text-xl font-bold tracking-widest text-slate-800"
                                        >
                                            {b}
                                        </div>
                                    ))}
                                </div>
                                <p className="mt-6 text-sm text-slate-500 leading-relaxed">
                                    कैंपेन स्ट्रैटेजी और कंज़्यूमर कम्युनिकेशन से लेकर रिटेल विज़िबिलिटी, ट्रेड मार्केटिंग, डिजिटल कैंपेन और मार्केट एक्ज़ीक्यूशन तक — गंभीर ब्रांड्स के पीछे का अनुशासन, अब लोकल बिज़नेस के लिए।
                                </p>
                                <p className="mt-4 text-xs text-slate-400 leading-relaxed">
                                    ब्रांड नाम केवल प्रोफ़ेशनल ब्रांड-मार्केटिंग अनुभव दर्शाते हैं। ALBL इन कंपनियों का आधिकारिक पार्टनर, प्रतिनिधि या एजेंसी नहीं है।
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="bg-[#0D131F] text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow dark>हम कैसे काम करते हैं</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15] mt-5">
                            कोई कॉपी-पेस्ट मार्केटिंग नहीं।
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
                        {HI_PROCESS.map((p) => (
                            <div key={p.num} className="bg-[#0D131F] p-8">
                                <span className="font-serif-accent italic text-3xl text-[#C5A059]">{p.num}</span>
                                <h3 className="font-display text-xl font-bold tracking-tight mt-4">{p.title}</h3>
                                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.text}</p>
                            </div>
                        ))}
                    </div>
                    <Reveal delay={150}>
                        <Link
                            to="/hi/contact?intent=audit"
                            data-testid="hi-about-cta-audit-button"
                            className="btn-sharp mt-12 inline-flex items-center gap-2 bg-[#C5A059] text-[#0D131F] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4"
                        >
                            ग्रोथ ऑडिट से शुरुआत करें <ArrowRight className="h-4 w-4" />
                        </Link>
                    </Reveal>
                </div>
            </section>

            <HiFinalCta />
        </main>
    );
};

export default HindiAbout;
